/**
 * Constants
 */
/** @private */
export const cellClick = 'cellClick';
/** @private */
export const cellDoubleClick = 'cellDoubleClick';
/** @private */
export const moreEventsClick = 'moreEventsClick';
/** @private */
export const select = 'select';
/** @private */
export const hover = 'hover';
/** @private */
export const actionBegin = 'actionBegin';
/** @private */
export const actionComplete = 'actionComplete';
/** @private */
export const actionFailure = 'actionFailure';
/** @private */
export const navigating = 'navigating';
/** @private */
export const renderCell = 'renderCell';
/** @private */
export const eventClick = 'eventClick';
/** @private */
export const eventDoubleClick = 'eventDoubleClick';
/** @private */
export const eventRendered = 'eventRendered';
/** @private */
export const dataBinding = 'dataBinding';
/** @private */
export const dataBound = 'dataBound';
/** @private */
export const popupOpen = 'popupOpen';
/** @private */
export const popupClose = 'popupClose';
/** @private */
export const dragStart = 'dragStart';
/** @private */
export const drag = 'drag';
/** @private */
export const dragStop = 'dragStop';
/** @private */
export const resizeStart = 'resizeStart';
/** @private */
export const resizing = 'resizing';
/** @private */
export const resizeStop = 'resizeStop';
/** @private */
export const inlineClick = 'inlineClick';
/** @private */
export const cellSelect = 'cellSelect';
/** @private */
export const virtualScrollStart = 'virtualScrollStart';
/** @private */
export const virtualScrollStop = 'virtualScrollStop';
/** @private */
export const noEvents = 'noEvents';
/** @private */
export const agendaCells = 'agendaCells';
/** @private */
export const resourceHeader = 'resourceHeader';
/** @private */
export const dateHeader = 'dateHeader';
/** @private */
export const beforePaste = 'beforePaste';
/**
 * Specifies schedule internal events
 */
/** @private */
export const initialLoad = 'initial-load';
/** @private */
export const initialEnd = 'initial-end';
/** @private */
export const print = 'print';
/** @private */
export const dataReady = 'data-ready';
/** @private */
export const eventsLoaded = 'events-loaded';
/** @private */
export const contentReady = 'content-ready';
/** @private */
export const scroll = 'scroll';
/** @private */
export const virtualScroll = 'virtual-scroll';
/** @private */
export const scrollUiUpdate = 'scroll-ui-update';
/** @private */
export const uiUpdate = 'ui-update';
/** @private */
export const documentClick = 'document-click';
/** @private */
export const documentPaste = 'document-paste';
/** @private */
export const cellMouseDown = 'cell-mouse-down';
